var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.988 19.268q.0705.6675.528 1.125c.328.304.714.457 1.16.457h8.648c.445 0 .832-.153 1.16-.457.305-.305.48-.68.528-1.125L18.75 7.35H5.25zM19.313 3.975h-3.938l-.422-.809a.498.498 0 0 0-.492-.316H9.539a.498.498 0 0 0-.492.316l-.422.809H4.687c-.351.023-.539.21-.562.562v1.125c.023.352.21.54.563.563h14.625c.351-.024.539-.211.562-.563V4.537c-.023-.351-.211-.539-.563-.562Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-icon.b1e9d0405a3700282d21e1be2989d973.svg";